<template>
    <div class="buyInfoItem">
        <img class="diamond_icon" src="../assets/img/diamond.png">
        <div class="fc-flex fc-flex-vcenter fc-flex1">
            <span class="buyNum">{{ normInfo.newNumber }}</span>
            <span class="morereward_txt" v-if="normInfo.awardNumber > 0">+{{ normInfo.awardNumber }}</span>
            <img class="morereward_img" :src="normInfo.img" v-if="normInfo.img && normInfo.isActivity">
        </div>
        <!--<div class="fc-btn-line-main payBtn" v-if="selCountryInfo.coding == 'CN'"-->
        <!--    @click="payforMoney(payType.rechargePayType, normInfo)">￥{{ normInfo.price_China }}</div>-->
        <div class="fc-btn-line-main payBtn" @click="payforMoney(payType.rechargePayType, normInfo)">
            {{ calLocalMoney() }}</div>
    </div>
</template>
<script>
import Vue from 'vue';
import { Dialog,Toast } from 'vant';
Vue.use(Dialog);
Vue.use(Toast);
import {  createOrderAjax, pagSmileCreateOrderAjax, payssionCreateOrderAjax,dlocalCreateOrderAjax,dukPayCreateOrderAjax} from "@/api/pay.js";
import { exitLogin } from "@/tools/common.js";
import {getAppName, getMoneySymbol} from "../util";
import {codaPayCreateOrderAjax, paymentWallPaypalCreateOrder, haiPayCreateOrderAjax} from '../api/pay';
import { loadingWebp } from '../assets/img/loading';

export default {
    name: "buyItem",
    props: {
        payType: {
            type: Object,
            default: function () {
                return {}
            }
        },
        normInfo: {
            type: Object,
            default: function () {
                return {}
            }
        },
        selCountryInfo: {
            type: Object,
            default: function () {
                return {}
            }
        },
        userInfo: {
            type: Object,
            default: function () {
                return {}
            }
        },
        domainCountry: {
            type: String,
            default: function () {
              return null
            }
        },
        from: {
            type: String,
            default: function () {
                return null
            }
        }
    },
    data() {
        return {
            payTypeArr: {
                0:'非三方聚合',
                1:'payerMax',
                2:'paymentWall',
                3:'RazerGlobal',
                4:'dpay',
                5:'币商',
                6:'pagSmile',
                7:'payssion',
                8:'dlocal',
                9:'Dukpay',
                10:'CodaPay',
                11:'paymentwall-PayPal',
                12:'HaiPay',
            },
            appName: getAppName(),
        };
    },
    watch: {

    },
    mounted() {

    },
    methods: {
        /**
         * 计算转换后的本地货币
         */
        calLocalMoney(userLocal = true) {
          if(this.selCountryInfo.coding === 'CN') {
            return `￥${this.normInfo.price_China}`
          }
          if(this.payType.rechargePayType.aggregatePay === 9 && this.payType.dukpayRate && this.normInfo.price_America && userLocal) {
            // 获取货币符号
            let symbol = getMoneySymbol(this.selCountryInfo.coding)
            let localMoney = Number((Math.floor(this.normInfo.price_America * this.payType.dukpayRate * 100) / 100).toFixed(2))
            return `${symbol}${localMoney}`
          }
          return `$${this.normInfo.price_America}`
        },
        payforMoney(item, info) {
            let payPlatformId = item.id;
            // console.log(item);
            // console.log(info);
            // return;
            let price = this.calLocalMoney();
            let aggregatePayTxt = this.payTypeArr[item.aggregatePay]||'非三方聚合';
            // 埋点
            this.$analytics.logEvent('PC_pay_price_click', {
                pay_country: this.selCountryInfo.content,
                paystyle_name: item.payTypeShowName,
                pay_price: this.calLocalMoney(false),
                aggregate_pay: aggregatePayTxt
            });
            // return
            if (!this.userInfo.token) {
                exitLogin();
                return false;
            }
            Dialog.confirm({
                message: this.$t('m.alertShowTxt1') + ' ' + price + ' ' + this.$t('m.alertShowTxt3') + ' ' + info.number +
                    ' ' + this.$t('m.alertShowTxt5'),
            }).then(() => {
                // on confirm
                // 记录充值金额到 localStorage
                localStorage.setItem('rechargeAmount', price);
                // 记录充值方式到 localStorage
                localStorage.setItem('rechargeType', item.payTypeShowName);
                if ((item.payTypeShowName == 'Visa & MasterCard')||(item.payTypeAgentCode=='cc'&&item.aggregatePay==2)) {
                    this.selPayStyleId = payPlatformId;
                    this.selPayStyleNormId = info.rechargeNormId;
                    // this.emailShow = true;
                    //  this.$router.push({ name: 'news', params: { userId: 123 }});
                    this.$router.push({
                        name: 'email',
                        params: {
                            userId: this.userInfo.userId,
                            token: this.userInfo.token,
                            selPayStyleId: payPlatformId,
                            selPayStyleNormId: info.rechargeNormId,
                            countryCode: this.selCountryInfo.coding,
                            from: this.from
                        }
                    })
                } else {
                    if(item.aggregatePay==6){
                        this.pagSmilePay(info.rechargeId, item.id, 0)
                        return false;
                    }
                    if(item.aggregatePay==7){
                        this.payssionPay(info.rechargeId, item.id, 0)
                        return false;
                    }
                    if(item.aggregatePay==8){
                        this.dlocalPay(info.rechargeId, item.id, 0)
                        return false;
                    }
                    if(item.aggregatePay==9){
                        this.dukPay(info.rechargeId, item.id, 0)
                        return false;
                    }
                    if(item.aggregatePay==10){
                        this.codaPay(info.rechargeId, item.id, 0)
                        return false;
                    }
                    // paymentwall旗下的paypal、klarna
                    if(item.aggregatePay === 11) {
                        this.createPaymentWallPaypal(info.rechargeId, item.id, 0)
                        return false;
                    }
                    if(item.aggregatePay === 12) {
                        this.haiPay(info.rechargeId, item.id, 0)
                        return false;
                    }
                    this.createOrderPay(payPlatformId, info.rechargeNormId, item.aggregatePay);
                }
            }).catch(() => {
                // on cancel
            });
        },

        // 常规支付方式下单
        createOrderPay(payPlatformId, rechargeId, aggregatePay) {
            if (payPlatformId == 2) {
                localStorage.setItem("IsWeChatPay", 'true');
            } else {
                localStorage.setItem("IsWeChatPay", 'false');
            }
            this.confirmPay(payPlatformId, rechargeId, aggregatePay, 0)
        },
        // 确认下单-常规支付方式，
        confirmPay(payPlatformId, rechargeId, aggregatePay, payPage = 0){
            Toast.loading({
                duration: 0, // 持续展示 toast
                forbidClick: true,
                icon: require("../assets/img/loading.gif"),
                className: 'loading'
            });
            var param = {
                "systoken": this.userInfo.token,
                "userId": this.userInfo.userId,
                "rechargeId": rechargeId,
                "countryCode": this.selCountryInfo.coding,
                "domainCountry": this.domainCountry,
                "from": this.from
            };
            // 记录充值金额到 localStorage
            localStorage.setItem('rechargeAmount', this.calLocalMoney());
          console.log("domain: ", this.domainCountry)
          let newWindow = null;
          if (payPlatformId == 3 || payPlatformId == 10075 || payPlatformId === 10076 || payPlatformId === 10078 || payPlatformId === 10091) {
              const isSafari = /^((?!chrome|android).)*safari/i.test(navigator.userAgent);
              if (isSafari) {
                const loadingHtml = `
                    <!DOCTYPE html>
                    <html>
                    <head>
                        <title>Redirecting to payment...</title>
                    </head>
                    <body>
                    </body>
                    </html>
                `;
                newWindow = window.open(`data:text/html;base64,${btoa(loadingHtml)}`, '_blank')
              } else {
                newWindow = window.open('', '_blank')
                newWindow.document.body.innerHTML = `
                  <div style="position: absolute; top: 50%; left: 50%; transform: translate(-50%, -50%);">
                    <img style="width: 140px; height: 60px;" src="${loadingWebp.base64}" alt="">
                  </div>
                `
              }
              newWindow.document.title = 'Redirecting to payment...'
            }
            createOrderAjax(param,payPlatformId,payPage,aggregatePay).then((res) => {
                // 如果 handleCreateOrderResult 标记为失败，阻止后续操作
                if (res && res.fail) {
                  newWindow && newWindow.close();
                  Toast.clear();
                  return;
                }
                // console.log(res.data);
                // return;
                Toast.clear();
                if (res.data.code == 1) {
                    var tradeNo = res.data.result.tradeNo;
                    //Toast(tradeNo+"___"+payPlatformId);
                    if (!tradeNo && payPlatformId == 2) {
                        Toast(this.$t('m.sys_error'));
                        return false;
                    }
                    //跳转第三方
                    if (payPlatformId == 3 || payPlatformId == 10075) {
                        //3 代表paypal, 10075代表新账号paypal
                        const targetUrl = this.global_paypalUrl + "/web/h5/pay/start?tradeNo=" + tradeNo;
                        newWindow.location.replace(targetUrl)
                    } else if(payPlatformId === 10076) {
                        //10076 代表意大利的paypal
                        const targetUrl = process.env.paypalUrl_IT + "/web/h5/pay/start?tradeNo=" + tradeNo;
                        newWindow.location.replace(targetUrl)
                    }  else if(payPlatformId === 10078) {
                        //10078 paypal新充值
                        const targetUrl = process.env.paypalUrl_10078 + "/web/h5/pay/start?tradeNo=" + tradeNo;
                        newWindow.location.replace(targetUrl)
                    } else if(payPlatformId === 10091) {
                        //10091 paypal新充值
                        const targetUrl = process.env.paypal_created_api_10091 + "/web/h5/pay/start?tradeNo=" + tradeNo;
                        newWindow.location.replace(targetUrl)
                    } else if (aggregatePay == 3 || aggregatePay == 4) {
                        newWindow && newWindow.close()
                        //新支付方式
                        window.location.href = tradeNo
                    } else {
                        newWindow && newWindow.close()
                        if(aggregatePay === 2) {
                          window.location.href = process.env.PAYMENTWALL_API + "/web/h5/pay/start?tradeNo=" + tradeNo;
                        } else {
                          window.location.href = this.global_apiUrl + "/web/h5/pay/start?tradeNo=" + tradeNo;
                        }
                    }
                } else if (res.data.code == 6000) {
                    newWindow && newWindow.close()
                    Dialog.alert({
                        message: this.$t('m.pay_fail_system_risk') + ', ' + this.$t('m.support_contant_whatsapp', { msg: this.appName }),
                        confirmButtonText: 'OK',
                        getContainer: '#payindex'
                    }).then(() => {
                        // on close
                    });
                } else if (res.data.code == 6001) {
                    newWindow && newWindow.close()
                    Dialog.alert({
                        message: this.$t('m.paystyle_unavailabel_change_other') + this.$t('m.support_contant_whatsapp', { msg: this.appName }),
                        confirmButtonText: 'OK',
                        getContainer: '#payindex'
                    }).then(() => {
                        // on close
                    });
                } else if (res.data.code == -1) {
                    newWindow && newWindow.close()
                    exitLogin();
                }
            }).catch((error) => {
                newWindow && newWindow.close()
                // console.log(error) //  错误处理 相当于error
                error.message ? Toast(error.message) : null;
            })
        },
        // pagSmile下单接口
        pagSmilePay(normId, payTypeId, payPage = 0) {
            // console.log({
            //     payTypeId:payTypeId,
            //     normId:normId
            // });
            Toast.loading({
                duration: 0, // 持续展示 toast
                forbidClick: true,
                icon: require("../assets/img/loading.gif"),
                className: 'loading'
            });
            // 记录充值金额到 localStorage
            localStorage.setItem('rechargeAmount', this.calLocalMoney());
            pagSmileCreateOrderAjax({
                payTypeId:payTypeId,
                normId:normId,
                countryCode: this.selCountryInfo.coding,
                domainCountry: this.domainCountry,
                from: this.from,
                payPage: payPage
            }, payPage).then(({data})=>{
                // 如果下单结果被标记为 fail，则阻止后续操作
                if (data && data.fail) {
                    Toast.clear();
                    return;
                }
                if(data.code==1&&data.data.payUrl){
                    Toast.clear();
                    window.location.href = data.data.payUrl;
                }else{
                    Toast(this.$t('m.failedPay'));
                }
            }).catch((error)=>{
                if(error.message) {
                    Toast(error.message);
                }else {
                    Toast.clear()
                }
            })
        },
        // payssion 下单接口
        payssionPay(normId, payTypeId, payPage = 0) {
            console.log(this.selCountryInfo);
            Toast.loading({
                duration: 0, // 持续展示 toast
                forbidClick: true,
                icon: require("../assets/img/loading.gif"),
                className: 'loading'
            });
            // 记录充值金额到 localStorage
            localStorage.setItem('rechargeAmount', this.calLocalMoney());
            payssionCreateOrderAjax({
                payTypeId:payTypeId,
                normId:normId,
                countryId: this.selCountryInfo.countryId,
                domainCountry: this.domainCountry,
                from: this.from,
                payPage: payPage
            }, payPage).then(({data})=>{
                if (data && data.fail) {
                    Toast.clear();
                    return;
                }
                if(data.code==1&&data.data.payUrl){
                    Toast.clear();
                    window.location.href = data.data.payUrl;
                }else{
                    Toast(this.$t('m.failedPay'));
                }
            }).catch((error)=>{
                if(error.message) {
                    Toast(error.message);
                }else {
                    Toast.clear()
                }
            })
        },

        // dlocal 下单接口
        dlocalPay(normId, payTypeId, payPage = 0) {
            console.log(this.selCountryInfo);
            Toast.loading({
                duration: 0, // 持续展示 toast
                forbidClick: true,
                icon: require("../assets/img/loading.gif"),
                className: 'loading'
            });
            // 记录充值金额到 localStorage
            localStorage.setItem('rechargeAmount', this.calLocalMoney());
            dlocalCreateOrderAjax({
                payTypeId:payTypeId,
                normId:normId,
                countryId: this.selCountryInfo.countryId,
                domainCountry: this.domainCountry,
                from: this.from,
                payPage: payPage
            }, payPage).then(({data})=>{
                if (data && data.fail) {
                    Toast.clear();
                    return;
                }
                if(data.code==1&&data.data.payUrl){
                    Toast.clear();
                    window.location.href = data.data.payUrl;
                }else{
                    Toast(this.$t('m.failedPay'));
                }
            }).catch((error)=>{
                if(error.message) {
                    Toast(error.message);
                }else {
                    Toast.clear()
                }
            })
        },
        // dukPay 下单接口
        dukPay(normId, payTypeId, payPage = 0) {
            console.log(this.selCountryInfo);
            Toast.loading({
                duration: 0, // 持续展示 toast
                forbidClick: true,
                icon: require("../assets/img/loading.gif"),
                className: 'loading'
            });
            // 记录充值金额到 localStorage
            localStorage.setItem('rechargeAmount', this.calLocalMoney());
            dukPayCreateOrderAjax({
                payTypeId:payTypeId,
                normId:normId,
                countryId: this.selCountryInfo.countryId,
                domainCountry: this.domainCountry,
                from: this.from,
                payPage: payPage
            }, payPage).then(({data})=>{
                if (data && data.fail) {
                    Toast.clear();
                    return;
                }
                if(data.code==1&&data.data.payUrl){
                    Toast.clear();
                    window.location.href = data.data.payUrl;
                }else{
                    Toast(this.$t('m.failedPay'));
                }
            }).catch((error)=>{
                if(error.message) {
                    Toast(error.message);
                }else {
                    Toast.clear()
                }
            })
        },
        // CodaPay 下单接口
        codaPay(normId, payTypeId, payPage = 0) {
            console.log(this.selCountryInfo);
            Toast.loading({
                duration: 0, // 持续展示 toast
                forbidClick: true,
                icon: require("../assets/img/loading.gif"),
                className: 'loading'
            });
            // 记录充值金额到 localStorage
            localStorage.setItem('rechargeAmount', this.calLocalMoney());
            codaPayCreateOrderAjax({
                payTypeId:payTypeId,
                normId:normId,
                countryId: this.selCountryInfo.countryId,
                domainCountry: this.domainCountry,
                from: this.from,
                payPage: payPage
            }, payPage).then(({data})=>{
                if (data && data.fail) {
                    Toast.clear();
                    return;
                }
                if(data.code==1&&data.data.payUrl){
                    Toast.clear();
                    window.location.href = data.data.payUrl+'?txn_id='+data.data.orderNo;
                }else{
                    Toast(this.$t('m.failedPay'));
                }
            }).catch((error)=>{
                if(error.message) {
                    Toast(error.message);
                }else {
                    Toast.clear()
                }
            })
        },
        // HaiPay 下单接口
        haiPay(normId, payTypeId, payPage = 0) {
            console.log(this.selCountryInfo);
            Toast.loading({
                duration: 0,
                forbidClick: true,
                icon: require("../assets/img/loading.gif"),
                className: 'loading'
            });
            localStorage.setItem('rechargeAmount', this.calLocalMoney());
            haiPayCreateOrderAjax({
                payTypeId: payTypeId,
                normId: normId,
                countryId: this.selCountryInfo.countryId,
                domainCountry: this.domainCountry,
                from: this.from,
                payPage: payPage
            }).then(({data}) => {
                if (data && data.fail) {
                    Toast.clear();
                    return;
                }
                if (data.code == 1 && data.data.payUrl) {
                    Toast.clear();
                    window.location.href = data.data.payUrl;
                } else {
                    Toast(this.$t('m.failedPay'));
                }
            }).catch((error) => {
                if (error.message) {
                    Toast(error.message);
                } else {
                    Toast.clear();
                }
            })
        },
        /**
         * paymentWall 旗下的paypal下单接口，走微服务，只有H5充值官网有，pc、pwa、安卓渠道包（现走官网充值）、ios渠道包都没有（appRecharge项目）
         * @param normId
         * @param payTypeId
         */
        createPaymentWallPaypal(normId, payTypeId, payPage = 0) {
          console.log(this.selCountryInfo);
          this.showLoading()
          // 记录充值金额到 localStorage
          localStorage.setItem('rechargeAmount', this.calLocalMoney());
          paymentWallPaypalCreateOrder({
            payTypeId:payTypeId,
            normId:normId,
            countryId: this.selCountryInfo.countryId,
            domainCountry: this.domainCountry,
            from: this.from,
            payPage: payPage
          }, payPage).then(({data})=>{
            if (data && data.fail) {
              Toast.clear();
              return;
            }
            if(data.code === 1 && data.data.payUrl){
              Toast.clear();
              window.location.href = process.env.baseURL + "/web/h5/pay/start?tradeNo=" + data.data.orderNo;
            }else{
              Toast(this.$t('m.failedPay'));
            }
          }).catch((error)=>{
            if(error.message) {
              Toast(error.message);
            }else {
              Toast.clear()
            }
          })
        },
        showLoading() {
          Toast.loading({
            duration: 0, // 持续展示 toast
            forbidClick: true,
            icon: require("../assets/img/loading.gif"),
            className: 'loading'
          })
        }
    },
};
</script>
<style></style>



// WEBPACK FOOTER //
// src/components/buyItem.vue